import type { granularityItem } from "app/components/widget/widget-utilities/time-granularity";
import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";

import type { MetricKey } from "../../types";
import { isMetricSupportedForGranularity } from "../config";

const ALL_GRANULARITY_OPTIONS = [toggleItems.Daily, toggleItems.Weekly, toggleItems.Monthly];

export type GranularityOption = {
    label: string;
    disabled: boolean;
    granularity: granularityItem;
};

export const getAvailableGranularityOptions = (
    selectedMetric: MetricKey,
    translateFn: (key: string) => string,
): GranularityOption[] => {
    return ALL_GRANULARITY_OPTIONS.map((option) => ({
        label: translateFn(option.title),
        disabled: !isMetricSupportedForGranularity(selectedMetric, option.value),
        granularity: option,
    }));
};

export const getCurrentGranularityIndex = (
    timeGranularity: granularityItem,
    availableOptions: GranularityOption[],
): number => {
    return availableOptions.findIndex((option) => option.granularity.value === timeGranularity.value);
};

const getGranularityFromIndex = (index: number): granularityItem | null => {
    return ALL_GRANULARITY_OPTIONS[index] || null;
};
